import React from "react"
import "../Styles/blognavbar.scss"
const Navsearch = () => (
<form > 
	<input type="search" placeholder="Search" id="searchbar"/>
</form>
)
export default Navsearch
